import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-l', 'LetterL', [["path",{"d":"M9 7v9.5h7","key":"svg-0"}]]);